import { z } from "zod";
import { EpochMillisSchema } from "./common.js";
/**
 * Réglages de site (SITE_SPEC — paramètres globaux éditables depuis l'admin).
 *
 * Un enregistrement UNIQUE (clé technique fixe côté BFF, ligne unique dans `web_settings`) porte les
 * réglages transverses affichés/consommés par le site : IP du serveur, lien Discord, réseaux sociaux.
 *
 * Surface :
 *   - PUBLIC : GET d'un sous-ensemble SÛR (serverIp, discordUrl, socials) — affiché aux visiteurs.
 *   - ADMIN  : PUT du réglage complet (role-gated), persisté dans `web_settings`.
 *
 * Les agents Fill (BFF `routes/settings.ts` + web réglages) construisent contre CES types — jamais
 * redéfinis ailleurs.
 */
/** Un lien de réseau social ({label, url, icon?}). */
export const SiteSocialLinkSchema = z.object({
    /** Libellé affiché (FR), ex « Discord », « TikTok ». */
    label: z.string().min(1).max(64),
    /** URL absolue du réseau. */
    url: z.string().url().max(512),
    /** Icône optionnelle (nom d'icône ou emoji). */
    icon: z.string().max(64).optional(),
});
/**
 * Réglages de site (miroir 1:1 de la ligne unique `web_settings`).
 *  - serverIp   : adresse de connexion Minecraft affichée aux joueurs (ex « play.etheria.fr »).
 *  - discordUrl : invitation Discord de la communauté.
 *  - socials    : liste (optionnelle) de liens de réseaux sociaux.
 *  - updatedAt  : epoch ms de la dernière écriture (posé côté serveur).
 */
export const SiteSettingsSchema = z.object({
    serverIp: z.string().max(255).default(""),
    discordUrl: z.string().max(512).default(""),
    socials: z.array(SiteSocialLinkSchema).optional(),
    updatedAt: EpochMillisSchema.default(0),
});
/**
 * Corps de mise à jour des réglages (admin). `updatedAt` est posé côté serveur (non fourni par le
 * client). Tous les champs sont fournis ensemble (remplacement de la ligne unique).
 */
export const SiteSettingsUpdateReqSchema = z.object({
    serverIp: z.string().max(255).default(""),
    discordUrl: z.string().max(512).default(""),
    socials: z.array(SiteSocialLinkSchema).default([]),
});
//# sourceMappingURL=settings.js.map